import apiClient from '@shared/services/apiClient';

export interface SettingDto {
  id: number;
  category: string;
  key: string;
  value: string;
  dataType: string;
  description: string | null;
  modifiedAt: string | null;
  modifiedByUserId: number | null;
}

export interface SettingsCategoryDto {
  category: string;
  settings: SettingDto[];
}

export interface AllSettingsDto {
  categories: SettingsCategoryDto[];
}

export const settingsApi = {
  getAllSettings: async (): Promise<AllSettingsDto> => {
    const response = await apiClient.get('/settings');
    return response.data;
  },

  getSettingsByCategory: async (category: string): Promise<SettingsCategoryDto> => {
    const response = await apiClient.get(`/settings/${category}`);
    return response.data;
  },

  getSetting: async (category: string, key: string): Promise<SettingDto> => {
    const response = await apiClient.get(`/settings/${category}/${key}`);
    return response.data;
  },

  updateSetting: async (category: string, key: string, value: string): Promise<{ message: string }> => {
    const response = await apiClient.put(`/settings/${category}/${key}`, { value });
    return response.data;
  },
};
